import React, { useState, useCallback } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import Button from 'components/DesignSystem/Button';
import InteractiveMap, {
  ESRI_SATELLITE_TILE_URL,
  ESRI_SATELLITE_TILE_ATTRIBUTION,
} from 'components/InteractiveMap';
import BrazilStatesLayer from 'components/Meteorology/Agro/BrazilStatesLayer';
import useLocationMarkers from 'hooks/Meteorology/Fields/TrackingForecast/Register/useLocationMarkers';
import { useSelector } from 'react-redux';
import RegisterLocationForm from 'components/LocationForm/RegisterLocationForm';
import EditGroupLocationForm from 'components/LocationForm/EditGroupLocationForm';
import RegisterMobile from 'components/Meteorology/Fields/TrackingForecast/Register/Mobile';
import {
  setCreateAlert,
  setEditAlert,
  selectMeteorologyFieldsGroupLocationCreateAlert,
  selectMeteorologyFieldsGroupLocationEditAlert,
} from 'redux/reducers/meteorologyFieldsGroupLocationFeedbackReducer';
import { store } from 'redux/store';
import useGroups from 'hooks/Meteorology/Fields/TrackingForecast/Register/useGroups';
import useLocations from 'hooks/Meteorology/Fields/TrackingForecast/Register/useLocations';
import useUpdateGroup from 'hooks/Meteorology/Fields/TrackingForecast/Register/useUpdateGroup';
import useUpdateLocation from 'hooks/Meteorology/Fields/TrackingForecast/Register/useUpdateLocation';
import useDeleteGroup from 'hooks/Meteorology/Fields/TrackingForecast/Register/useDeleteGroup';
import useDeleteLocation from 'hooks/Meteorology/Fields/TrackingForecast/Register/useDeleteLocation';
import useSaveGroup from 'hooks/Meteorology/Fields/TrackingForecast/Register/useSaveGroup';
import useCities from 'hooks/Meteorology/Fields/TrackingForecast/Register/useCities';
import useFieldsSaveLocationParams from 'hooks/Meteorology/Fields/TrackingForecast/Register/RegisterForm/useFieldsSaveLocationParams';
import useIsMobile from 'utils/hooks/useIsMobile';

export default function Register() {
  const isMobile = useIsMobile();
  const markers = useLocationMarkers();
  const [registering, setRegistering] = useState(false);
  const [editing, setEditing] = useState(false);

  const { groups } = useGroups();
  const { locations } = useLocations();
  const { cities } = useCities();
  const { deleteGroup } = useDeleteGroup();
  const { deleteLocation } = useDeleteLocation();
  const { updateGroup } = useUpdateGroup();
  const { updateLocation } = useUpdateLocation();

  const {
    saveGroup,
  } = useSaveGroup();

  const {
    saveLocationParams,
  } = useFieldsSaveLocationParams();

  const alertEdit = useSelector(selectMeteorologyFieldsGroupLocationEditAlert);
  const alertRegister = useSelector(selectMeteorologyFieldsGroupLocationCreateAlert);

  const onRegisterHide = useCallback(() => {
    setRegistering(false);
    store.dispatch(setCreateAlert(undefined));
  }, []);
  const onEditHide = useCallback(() => {
    setEditing(false);
    store.dispatch(setEditAlert(undefined));
  }, []);

  if (isMobile) {
    return <RegisterMobile />;
  }

  return (
    <Card className="shadow-sm forecast-instruction-card m-5 p-4">
      <Row className="d-flex justify-content-end">
        <Col className="col-3 d-flex flex-row gap-1 justify-content-end">
          <Button icon="add" onClick={() => setRegistering(true)}>Cadastrar</Button>
          <Button type="secondary" icon="edit" onClick={() => setEditing(true)}>Editar</Button>
        </Col>
      </Row>
      <div className="d-flex flex-row justify-content-center m-3">
        <div className="w-50 z-2">
          <InteractiveMap
            markers={markers}
            tileUrl={ESRI_SATELLITE_TILE_URL}
            tileAttribution={ESRI_SATELLITE_TILE_ATTRIBUTION}
          >
            <BrazilStatesLayer />
          </InteractiveMap>
        </div>
      </div>
      <RegisterLocationForm
        show={registering}
        onHide={onRegisterHide}
        alert={alertRegister}
        groups={groups}
        saveGroup={saveGroup}
        saveLocationParams={saveLocationParams}
        cities={cities}
      />
      <EditGroupLocationForm
        show={editing}
        onHide={onEditHide}
        groups={groups}
        locations={locations}
        deleteGroup={deleteGroup}
        deleteLocation={deleteLocation}
        updateGroup={updateGroup}
        updateLocation={updateLocation}
        alert={alertEdit}
      />
    </Card>
  );
}
